import {
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  checkExistingCollections,
  createFundPayments,
  updateFundPayment,
} from '../../../../../../../../../../../lib/api/funds';
import CustomButton from '../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../../../../../../../lib/designSystem/HeaderWithActions';
import {
  formatMoney,
  formatMoneyBack,
} from '../../../../../../../../../../../lib/functions/utils';
import { showAlert } from '../../../../../../../../../../../lib/functions/utils';
import CollectionsWarningDialog from '../../../../../../../../../../../pages/Finance/Components/Funds/FactoringFundReSell/components/MultiPayment/components/CollectionsWarningDialog';

const FundPayment = (props: any) => {
  const {
    open,
    resell,
    setOpen,
    setUp,
    fundId,
    edit,
    fundPayment,
    setFundPayment,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openCollectionsWarning, setOpenCollectionsWarning] = useState(false);
  const [documentsWithWarnings, setDocumentsWithWarnings] = useState<any[]>([]);
  const [validationLoading, setValidationLoading] = useState(false);
  const validParams = () => {
    if (!fundPayment.amount || !fundPayment.date) {
      showAlert(dispatch, 'warning', 'Debes completar todos los campos');
      return false;
    }
    return true;
  };

  const handleCheckCollections = async () => {
    if (!validParams()) {
      return;
    }

    setValidationLoading(true);

    try {
      const paymentsToCheck = [
        {
          factoringResellId: resell.id,
          amount: fundPayment.amount,
          documentId: resell.document.id,
        },
      ];

      const result = await checkExistingCollections(dispatch, {
        payments: paymentsToCheck,
      });

      setValidationLoading(false);

      if (result.hasWarnings) {
        const docsWithWarnings = result.documentsWithCollections.filter(
          (doc: any) => doc.hasExistingCollections || doc.wouldCreateExcess,
        );
        setDocumentsWithWarnings(docsWithWarnings);
        setOpenCollectionsWarning(true);
      } else {
        await handleSubmit();
      }
    } catch (error) {
      setValidationLoading(false);
      showAlert(dispatch, 'error', 'Error al validar el pago');
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setOpenCollectionsWarning(false);
    try {
      const payments = [
        {
          factoringResellId: resell.id,
          businessIdentifier: resell.document.businessIdentifier,
          documentId: resell.document.id,
          date: new Date(fundPayment.date),
          amount: fundPayment.amount,
          fundId: resell.fundId,
        },
      ];
      if (edit) {
        await updateFundPayment(dispatch, {
          id: fundId,
          paymentId: fundPayment.id,
          payment: payments[0],
        });
      } else {
        const newPayload = {
          payments,
        };
        const { surplusWarnings } = await createFundPayments(
          dispatch,
          newPayload,
        );
        if (
          surplusWarnings &&
          Array.isArray(surplusWarnings) &&
          surplusWarnings.length > 0
        ) {
          showAlert(
            dispatch,
            'warning',
            'Pago registrado correctamente. Hubo un error al crear el excedente de la venta.',
          );
        }
      }
      setOpen(false);
      if (!edit) {
        showAlert(dispatch, 'success', 'Pago registrado correctamente');
      } else {
        showAlert(dispatch, 'success', 'Pago registrado correctamente');
      }
      await setUp();
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Error al guardar el pago');
    }
    setLoading(false);
  };

  useEffect(() => {}, []);

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={() => setOpen(false)}
      >
        <HeaderWithActions
          title={edit ? `Editar pago` : `Nuevo pago`}
          type="dialog"
        />
        {loading || validationLoading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <DialogContent>
            <Typography variant="body1">Ingrese los datos del pago</Typography>
            <TextField
              label="Monto"
              fullWidth
              margin="dense"
              value={formatMoney(fundPayment.amount)}
              onChange={(e) => {
                setFundPayment({
                  ...fundPayment,
                  amount: formatMoneyBack(e.target.value),
                });
              }}
            />
            <TextField
              label="fecha"
              fullWidth
              type="date"
              margin="dense"
              value={fundPayment.date}
              onChange={(e) => {
                setFundPayment({
                  ...fundPayment,
                  date: e.target.value,
                });
              }}
            />
          </DialogContent>
        )}
        <DialogActions>
          <CustomButton onClick={() => setOpen(false)} color="secondary">
            Salir
          </CustomButton>
          <CustomButton
            disabled={loading || validationLoading}
            onClick={() => handleCheckCollections()}
            color="primary"
          >
            Guardar
          </CustomButton>
        </DialogActions>
      </Dialog>
      {openCollectionsWarning && (
        <CollectionsWarningDialog
          open={openCollectionsWarning}
          onClose={() => setOpenCollectionsWarning(false)}
          onConfirm={() => void handleSubmit()}
          documentsWithWarnings={documentsWithWarnings}
        />
      )}
    </div>
  );
};

export default FundPayment;
